/**
 * For the website live public demo, disable some features for security and to
 * conserve system resources
 */
export const DEMO_MODE: boolean = true;

/**
 * A message that can be displayed on features that are disabled
 */
export const DEMO_MODE_DISABLED_TEXT = "Disabled in Demo Mode";
